import React from 'react';
import ReactMarkdown from 'react-markdown';
import { TERMS_TEXT } from './TermsText';

const Terms = () => {
    return (
        <div style={{ padding: '40px', maxWidth: '800px', margin: '40px auto', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <ReactMarkdown>{TERMS_TEXT}</ReactMarkdown>
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <button 
                    onClick={() => window.history.back()}
                    style={{ padding: '10px 20px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                >
                    Назад
                </button>
            </div>
        </div>
    );
};

export default Terms;
